<!--
 * @Author: zql
 * @Date: 2020-03-13 15:29:14
 * @LastEditTime: 2020-06-02 14:35:29
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \enfry-components\packages\components\en-result\src\brokenNet\broken-net.vue
-->
<template>
  <div
    ref="BrokenNet"
    class="brokennet"
  >
    <img
      slot="icon"
      class="icon-img"
      src="http://cdn.enfry.com/broken-net11298.png"
      :alt="this.title"
    >
    <div class="title" v-html="title"></div>
    <div class="subtitle" v-html="subTitle"></div>
  </div>
</template>

<script>
export default {
  name: "BrokenNet",
  props: {
    type: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    iconSize: {
      type: [String, Number],
      default: "normal"
    },
    title: {
      type: String,
      default: null
    },
    subTitle: {
      type: String,
      default: "断网了~请检查网络"
    }
  }

}
</script>
<style lang="scss" scoped>
  .brokennet {
    text-align: center;

    .icon-img {
      height: 95px;
      width: 93px;
    }
  }
</style>

